import { getCookie } from "./cookieUtils";
import { useEffect, useRef, useState } from "react";
import LoginBox from "./LoginBox";
import TrackingBox from "./TrackingBox";
import { toast } from "react-toastify";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FileUploader } from "react-drag-drop-files";


const PODUpload = () => {
    const inputrefs = useRef({})
    const [loginToken, setLoginToken] = useState(getCookie("loginToken") || null);
    const [userName, setUserName] = useState(getCookie("userName") || "");
    const [accessType, setAccessType] = useState(getCookie("accessType") || "");
    const fileTypes = ["JPG", "JPEG", "PNG"];
    const [msg, setMsg] = useState("");
    const [loading, setLoading] = useState(false);
    const [file, setFile] = useState(null);

    // Common headers for API calls
    const apiConfig = {
        AuthToken: "NASSKD28462RWKF35793FWEU757",
        LoginUserCode: userName,
        LoginToken: loginToken,
    };

    const [formData, setFormData] = useState({
        awbNo: "",
        ImageBase64: "",
    });

    const handleFileChange = async (e) => {
        const selected = e.target.files[0];
        if (!selected) return;

        const allowedTypes = ["jpg", "jpeg", "png"];
        const ext = selected.name.split(".").pop().toLowerCase();

        if (!allowedTypes.includes(ext)) {
            toast.error("Only jpg, jpeg, png allowed");
            return;
        }

        if (selected.size > 4 * 1024 * 1024) {
            toast.error("Max file size is 4MB");
            return;
        }

        try {
            const base64 = await convertToBase64(selected);

            setFile(selected);

            setFormData((prev) => ({
                ...prev,
                ImageBase64: base64,
                fileExt: ext,
                fileName: selected.name
            }));

        } catch (err) {
            toast.error("File processing failed");
        }
    };

    const convertToBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);

            reader.onload = () => {
                const base64 = reader.result.split(",")[1];
                resolve(base64);
            };

            reader.onerror = reject;
        });
    };

    const UploadPOD = async (e) => {
        e.preventDefault();
        try {

            setLoading(true);

            const payload = {
                ...apiConfig,
                AwbNo: formData.awbNo,
                ImageBase64: formData.ImageBase64 || ""
            };
            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/UploadPOD/UploadPODImage`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(payload)
            });

            const res = await response.json();

            if (res.status === "Success") {
                toast.success(res.message);
                setMsg(res?.message);
                setFormData({
                    awbNo: "",
                    ImageBase64: "",
                    fileExt: "",
                    fileName: ""
                });
            } else {
                toast.error(res.message);
                const focusField = res?.focus || res?.Focus;
                if (focusField && inputrefs.current[focusField]) {
                    inputrefs.current[focusField].focus();
                }
            }

        } catch (err) {
            console.error(err);
            toast.error("Upload failed");
        } finally {
            setLoading(false);
        }
    };


    const handleLoginSuccess = (loginData) => {
        setLoginToken(loginData.loginToken);
        setUserName(loginData.userName);
        setAccessType(loginData.accessType);
    };

    // Reset form
    const handleReset = () => {
        setFormData({
            awbNo: "",
            imageBase64: "",
            fileExt: "",
            fileName: ""
        });

        setFile(null);
        setMsg("");
        setTimeout(() => {
            if (inputrefs.current["txtAwbNo"]) inputrefs.current["txtAwbNo"].focus();
        }, 0);
    };

    useEffect(() => {
        inputrefs.current["txtAwbNo"].focus();
      
    }, []);

    return (
        <>
<section>
                <div className="container-fluid">
                    <img src="images/innerbanner.webp" className='img-fluid' alt="" />
                </div>
            </section>

            {/* MAIN SECTION */}
            <section className="main-section">
                <div className="container">
                    <div className="row g-4">

                        {/* SIDEBAR */}
                        <div className="col-lg-3">
                            <TrackingBox />
                            <LoginBox onLoginSuccess={handleLoginSuccess} />

                            {/* Contact */}
                            <div className="contact-card">
                                <div className="contact-title">Contact</div>
                                <div className="contact-item">
                                    <div className="contact-icon phone">
                                        <i className="fa fa-phone"></i>
                                    </div>
                                    <a href="tel:01141606842">+91 96672 33072</a>
                                </div>
                                <div className="contact-item">
                                    <div className="contact-icon email">
                                        <i className="fa fa-envelope"></i>
                                    </div>
                                    <a href="#">oxford_express@yahoo.co.in</a>
                                </div>
                                <div className="contact-item">
                                    <div className="contact-icon email">
                                        <i className="fa fa-envelope"></i>
                                    </div>
                                    <a href="#">info@oxfordexp.com</a>
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-9">
                            <div className="d-flex align-items-center gap-3 mb-3">
                                <h4 className="mb-0">POD Upload</h4>

                                {msg && (
                                    <h6
                                        className={`mb-0 fw-semibold ${msg === "POD Image Updated Successfully"
                                                ? "text-success"
                                                : "text-danger"
                                            }`}
                                    >
                                        {msg}
                                    </h6>
                                )}
                            </div>
                           

                            <form onSubmit={UploadPOD}>
                                <div className="row g-3">

                                    {/* AWB */}
                                    <div className="col-md-4">
                                        <label>AWB No <span className="text-danger">*</span></label>
                                        <input
                                            id="txtAwbNo"
                                            ref={(el) => (inputrefs.current["txtAwbNo"] = el)}
                                            type="text"
                                            placeholder="Enter AWB No."
                                            className="track-input"
                                            value={formData.awbNo}
                                            onChange={(e) =>
                                                setFormData({ awbNo: e.target.value })
                                            }
                                            onKeyDown={(e) => {
                                                if (e.key === "Enter") {
                                                    inputrefs.current["btnSub"]?.focus();
                                                }
                                            }}
                                        />
                                    </div>

                                    {/* FILE */}
                                    <div className="col-md-6">
                                        <label>Upload Image *</label>

                                        <FileUploader
                                            handleChange={(file) => handleFileChange({ target: { files: [file] } })}
                                            name="file"
                                            types={fileTypes}
                                            multiple={false}   
                                        />
                                    </div>

                                </div>

                                {/* BUTTONS */}
                                <div className="mt-4 d-flex gap-3 w-50 ">
                                    <button className="track-btn" disabled={loading} id="btnSub"
                                        ref={(el) => (inputrefs.current["btnSub"] = el)}
                                    >
                                        {loading ? "Uploading..." : "Upload"}
                                    </button>

                                    <button type="button" className="login-btn" onClick={handleReset}>
                                        Reset
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </section>

            {/* STATS STRIP */}
            <section className="stats-strip">
                <div className="container">
                    <div className="row g-0 text-center">
                        <div className="col-6 col-md-3 stat-item py-2">
                            <div className="stat-number">4.5L+</div>
                            <div className="stat-label">Packets / Month</div>
                        </div>
                        <div className="col-6 col-md-3 stat-item py-2">
                            <div className="stat-number">1000+</div>
                            <div className="stat-label">Cities Covered</div>
                        </div>
                        <div className="col-6 col-md-3 stat-item py-2">
                            <div className="stat-number">35+</div>
                            <div className="stat-label">Years Experience</div>
                        </div>
                        <div className="col-6 col-md-3 stat-item py-2">
                            <div className="stat-number">10K+</div>
                            <div className="stat-label">Happy Clients</div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default PODUpload;

